import VerticalSpace from '@src/component/VerticalSpace'
import {formatString} from '@src/constant'
import {getItemObj} from '@src/util/store'
import {Button} from 'antd-mobile'
import moment from 'moment'
import React from 'react'
import './clientCard.scss'

// const formatString = 'YYYY-MM-DD HH:mm'

function ClientCard({detail, pickSaler}: any) {
    const {isManager} = getItemObj('userInfo')
    const {
        name,
        mobile,
        mktime,
        modelname,
        dealerUserName,
        asigntime,
        contacted,
        dealeruserid,
        id,
    } = detail

    const showSelect = (id: number, type: 'pick' | 'confirm') => {
        pickSaler?.(id, type)
    }

    const remark = (type: 'pick' | 'confirm') => {
        showSelect(id, type)
        // if (isManager === 1) {
        //   console.log(1)
        //   // 指派
        //   showSelect(id)
        // } else {
        //   // 联系
        //   console.log(2)
        // }
    }

    return (
        <div className="card-box">
            <div className="left">
                <VerticalSpace justify="between" style={{height: '100%'}}>
                    <div style={{fontSize: 16}}>
                        {name} {mobile}
                    </div>
                    <div>留资时间：{moment(mktime).format(formatString)}</div>
                    <div>意向车型：{modelname}</div>
                    {isManager === 1 && <div>跟单销售：{dealerUserName}</div>}
                    {isManager === 1 && (
                        <div>
                            指派时间：
                            {asigntime ? moment(asigntime).format(formatString) : ''}
                        </div>
                    )}
                    {isManager === 1 && (
                        <div>是否已联系：{contacted === 0 ? '否' : '是'}</div>
                    )}
                    {isManager === 0 && (
                        <div>
                            开始跟进时间：
                            {asigntime ? moment(asigntime).format(formatString) : ''}
                        </div>
                    )}
                </VerticalSpace>
            </div>
            <div className="right">
                <VerticalSpace justify="between" style={{height: '100%'}} align="end">
                    {(isManager === 1 && !dealeruserid)
                    ?  <Button
                            color="primary"
                            size="small"
                            style={{'--background-color': '#6291DF'}}
                            onClick={() => remark('pick')}
                        >
                            指派
                        </Button>
                    : <div></div>
                    }
                    {!contacted ? <Button
                        color="primary"
                        size="small"
                        style={{'--background-color': '#6291DF'}}
                        onClick={() => remark('confirm')}
                    >
                        标记已联系
                    </Button>: <div></div>}
                </VerticalSpace>
            </div>
        </div>
    )
}

export default ClientCard
